import { render } from "./dotsLoader.vue?vue&type=template&id=a8a6a578"
const script = {}

import "./dotsLoader.vue?vue&type=style&index=0&id=a8a6a578&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__